import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { ThemeProvider } from "./contexts/ThemeContext"
import { Layout } from "./components/Layout"
import { FencersPage } from "./pages/FencersPage"
import { AttendancePage } from "./pages/AttendancePage"
import { StatisticsPage } from "./pages/StatisticsPage"
import { FencerDetailsPage } from "./pages/FencerDetailsPage"
import { CompetitionsPage } from "./pages/CompetitionsPage"
import { CompetitionDetailsPage } from "./pages/CompetitionDetailsPage"

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<AttendancePage />} />
            <Route path="/fencers" element={<FencersPage />} />
            <Route path="/fencers/:id" element={<FencerDetailsPage />} />
            <Route path="/competitions" element={<CompetitionsPage />} />
            <Route path="/competitions/:id" element={<CompetitionDetailsPage />} />
            <Route path="/statistics" element={<StatisticsPage />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  )
}

export default App
